import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * シンタックスハイライト付きコードブロックコンポーネント
 *
 * highlight.js を使用してコードをハイライト表示。
 * Python / JavaScript の言語切り替えに対応。
 * classNames でスタイルをカスタマイズ可能。
 */
import hljs from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import python from 'highlight.js/lib/languages/python';
import { useMemo } from 'react';
import { cn } from '../utils';
import { CopyButton } from './CopyButton';
// 言語を登録
hljs.registerLanguage('python', python);
hljs.registerLanguage('javascript', javascript);
/**
 * 言語に応じたデフォルトラベルを取得
 */
function getDefaultLabel(language) {
    switch (language) {
        case 'python':
            return 'Python';
        case 'javascript':
            return 'Node.js';
        default:
            return language;
    }
}
export function CodeBlock({ code, language, label, className, classNames }) {
    const displayLabel = label ?? getDefaultLabel(language);
    const highlightedHtml = useMemo(() => {
        try {
            const result = hljs.highlight(code, { language });
            return result.value;
        }
        catch {
            return null;
        }
    }, [code, language]);
    return (_jsxs("div", { className: cn('relative rounded-md', classNames?.root, className), "data-testid": "code-block", children: [_jsxs("div", { className: cn('flex items-center justify-between border-b px-3 py-1.5', classNames?.header), children: [_jsx("span", { className: cn('text-xs font-medium', classNames?.headerLabel), children: displayLabel }), _jsx(CopyButton, { content: code, className: classNames?.copyButton, "aria-label": "\u30B3\u30FC\u30C9\u3092\u30B3\u30D4\u30FC" })] }), _jsx("div", { className: cn('overflow-x-auto px-1.5 py-1', classNames?.codeWrapper), children: highlightedHtml ? (_jsx("pre", { className: cn('text-xs font-mono whitespace-pre leading-relaxed !bg-transparent !p-0 !m-0', classNames?.pre), children: _jsx("code", { className: cn('hljs !bg-transparent', classNames?.code), 
                        // biome-ignore lint/security/noDangerouslySetInnerHtml: highlight.js の出力を表示
                        dangerouslySetInnerHTML: { __html: highlightedHtml } }) })) : (_jsx("pre", { className: cn('text-xs font-mono whitespace-pre leading-relaxed', classNames?.pre), children: code })) })] }));
}
//# sourceMappingURL=CodeBlock.js.map